import react, { use, useEffect, useState } from "react";
import './news.css'
import axios from "axios";

const News = ({ heading, query, api }) => {
  const [news, setNews] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const newsdata = await axios.get(`${api}`)
        setNews(newsdata.data.articles)
      }
      catch (err) {
        console.log(err);
      }
    }
    fetchData();
  }, [api])

  useEffect(() => {

  }, [])
  return (
    <>
      {(!news || news.length === 0) ? (
        <p style={{ padding: "15px" }}>Loading news...</p>
      ) : (
        <section className="news-section">
          <div className="container">
            <div className="row">
              <div className="main-heading">
                <h3>{heading}</h3>
              </div>
              <div className="main-box">
                <div className="box">
                  <div className="content">
                    <div className="image">
                      <a href={news[0].url} target="_blank" aria-label={news[0].title}>
                        <img src={news[0].image} alt={news[0].title} />
                      </a>
                    </div>
                    <div className="detail">
                      <a href={news[0].url} target="_blank" aria-label={news[0].title}>
                        {news[0].description}
                      </a>
                    </div>
                  </div>
                </div>
                <div className="box">
                  <div className="content">
                    <div className="detail">
                      <ul>
                        {
                          news.slice(1, 6).map(({ url, title, image }, index) => (
                            <li key={url || index}>
                              <a href={url} target="_blank" aria-label="no image">
                                <img src={image} alt="no_image" />
                                {title}
                              </a>
                            </li>
                          ))
                        }
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section >
      )}
    </>
  )
}

export default News;